import React, { Component } from 'react';
import PageName from "../common/PageName.js";
import DashboardContent from "./DashboardContent";

class index extends Component {
  render() {
    return (
      <div className="col-12 noprint">
        <PageName
          parentState={this.props.parentState}
          liftGlobalState={this.props.liftGlobalState}
          liftState={this.props.liftState}
          parentProps={this.props.parentProps}
        />
        <DashboardContent
          parentState={this.props.parentState}
          parentProps={this.props.parentProps}
          liftState={this.props.liftState}
          liftGlobalState={this.props.liftGlobalState}
        />
      </div>
    );
  }
}

export default index;